module.exports = __webpack_public_path__ + "static/media/csv-download.62dc7b2b.svg";